"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rejectProposedSchedule = exports.acceptProposedSchedule = exports.updateScheduleRowStatus = exports.fetchScheduleRow = exports.fetchCompletedOrderLegs = exports.fetchDriverScheduleOrderLegs = exports.fetchDriverScheduleOrders = exports.fetchProposedDriverSchedule = exports.fetchCompletedDriverSchedule = exports.fetchActiveDriverSchedule = exports.fetchSchedules = void 0;
var snakecase_keys_1 = __importDefault(require("snakecase-keys"));
var config_1 = __importDefault(require("../../config"));
var base_1 = require("./base");
var fetchSchedules = function (token) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.driverSchedules), token, 'GET')];
}); }); };
exports.fetchSchedules = fetchSchedules;
var fetchActiveDriverSchedule = function (token) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.activeDriverSchedule), token, 'GET')];
}); }); };
exports.fetchActiveDriverSchedule = fetchActiveDriverSchedule;
var fetchCompletedDriverSchedule = function (token, startDate, endDate) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.completedDriverSchedule, "?start_date=").concat(startDate, "&end_date=").concat(endDate), token, 'GET')];
    });
}); };
exports.fetchCompletedDriverSchedule = fetchCompletedDriverSchedule;
var fetchProposedDriverSchedule = function (token) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.proposedDriverSchedule), token, 'GET')];
}); }); };
exports.fetchProposedDriverSchedule = fetchProposedDriverSchedule;
var fetchDriverScheduleOrders = function (token) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.driverScheduleOrders), token, 'GET')];
}); }); };
exports.fetchDriverScheduleOrders = fetchDriverScheduleOrders;
var fetchDriverScheduleOrderLegs = function (token) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.driverScheduleOrderLegs), token, 'GET')];
}); }); };
exports.fetchDriverScheduleOrderLegs = fetchDriverScheduleOrderLegs;
var fetchCompletedOrderLegs = function (token, startDate, endDate) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.driverCompletedOrderLegs, "?start_date=").concat(startDate, "&end_date=").concat(endDate), token, 'GET')];
    });
}); };
exports.fetchCompletedOrderLegs = fetchCompletedOrderLegs;
var fetchScheduleRow = function (token, rowId) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.scheduleRow).concat(rowId, "/"), token, 'GET')];
}); }); };
exports.fetchScheduleRow = fetchScheduleRow;
var updateScheduleRowStatus = function (token, scheduleId, data) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.driverSchedules).concat(scheduleId, "/driver_update_status/"), token, 'POST', { 'Content-Type': 'application/json' }, JSON.stringify((0, snakecase_keys_1.default)(data)))];
    });
}); };
exports.updateScheduleRowStatus = updateScheduleRowStatus;
var acceptProposedSchedule = function (token, scheduleID) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.driverSchedules).concat(scheduleID, "/driver_accept_schedule/"), token, 'POST')];
    });
}); };
exports.acceptProposedSchedule = acceptProposedSchedule;
var rejectProposedSchedule = function (token, scheduleID, reason) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.driverSchedules).concat(scheduleID, "/driver_reject_schedule/"), token, 'POST', { 'Content-Type': 'application/json' }, JSON.stringify({ reason: reason }))];
    });
}); };
exports.rejectProposedSchedule = rejectProposedSchedule;
